import React from 'react';
import { Button,Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import APPstyles from '@/App.less';
import styles from './Apply.less';

class NoticeIndex extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      
    }
  }
  render(){
    return (
      <Modal 
        centered={true}
        closeIcon={null}
        footer={null}
        maskClosable={false}
        open={true}
        transitionName=''
        maskTransitionName=''
        className={[styles.noticeModalCon,APPstyles.flex_column,APPstyles.color_white].join(' ')}
      >
        <span style={{marginBottom:10}}>啟用美國股市即時行情：</span>
        <p>1.為了讓您享有更即時、準確的美股行情資訊，富邦證券透過專業資訊服務商「路孚特」，向紐約證券交易所（NYSE）採購即時報價服務。</p>
        <p>2.依據NYSE規定，凡接收即時行情資訊之用戶，皆須親自簽署《資訊訂閱者同意書》，以供交易所日後查覈，並確認您已瞭解並同意相關使用規範。</p>
        <p>3.接下來，系統將引導您進入簽署頁面。完成簽署後，即可啟用美股即時報價服務。此為交易所之標準程序，旨在保障您的權益與資訊的合規使用。</p>
        <p>4.此外，富邦證券將依據個人資料保護法及相關法令，妥善保存您所提供的資料，並僅於提供即時報價服務之必要範圍內使用，不會將您的個人資料提供予任何第三人或作其他用途。</p>
        <div className={APPstyles.flex_center}>
          <Button className={styles.notice_btn} onClick={()=>this.props.closeNoticeChlick()}>確定</Button>
        </div>
      </Modal>
  )}
}
export default withTranslation()(NoticeIndex);